import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { Pagination } from '@/types/global';

type Patient = {
  id: number;
  patient_first_name: string;
  patient_last_name: string;
  patient_gender_code: 1 | 2;
  gender: string;
  date_of_birth: string;
  patient_state: string;
  patient_phone_number: string;
};

type PatientResponse = { data: Patient[]; meta: Pagination };

export type Params = {
  firstName?: string;
  lastName?: string;
  dateOfBirth?: string;
  medicalRecordNumber?: string;
  page?: number;
  per?: number;
  searchTrigger?: number;
};

export const useQueryPatients = ({
  firstName,
  lastName,
  dateOfBirth,
  medicalRecordNumber,
  page,
  per,
  searchTrigger = 0,
}: Params) => {
  const formatDateInput = (value: string) => {
    return value?.replace(/\//g, '-');
  };

  return useQuery({
    queryKey: ['patients', page, per, searchTrigger],
    queryFn: async () => {
      const params = new URLSearchParams();

      if (firstName) params.append('first_name', firstName);
      if (lastName) params.append('last_name', lastName);
      if (dateOfBirth) {
        const formattedDate = formatDateInput(dateOfBirth);
        params.append('date_of_birth', formattedDate);
      }
      if (medicalRecordNumber) {
        params.append('medical_record_number', medicalRecordNumber);
      }

      const url = `patients?page=${page}&per=${per}&${params.toString()}`;
      const response = await axios.get<PatientResponse>(url);

      return {
        data: response.data as unknown as Patient[],
        pagination: response.meta,
      };
    },
    enabled: searchTrigger === 0 || searchTrigger > 0,
  });
};
